export class Pattern {
  public static NAME = "^([A-ZÁÉÍÓÚa-zñáéíóúñÑ' ])+$";
  public static EMAIL =
    /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
  // public static EMAIL = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  public static TEXT = '^([A-ZÁÉÍÓÚa-zñÑáéíóú0-9.,\'"/# ]+[s]*)+$';
  public static STREET = /^[A-ZÁÉÍÓÚa-zñáéíóú0-9.,#-'/ ]$/g;
  public static NUMBER = '^([0-9])+$';
  public static URL = /^https?:\/\/[\w\-]+(\.[\w\-]+)+[/#?]?.*$/;
}
